// A CSV/XLSX export requested from a filtered list. The API creates it
// asynchronously, so the screen polls until `isReady`, then links to `url`.
// Every field is optional because the state starts as an empty object, before
// any report has been requested.
export interface Report {
  id?: number;
  isReady?: boolean;
  url?: string;
}

// What the shared reports reducer needs to find on the state it is given.
export interface ReportableState {
  report: Report;
}

export interface ReportsAction {
  type: string;
  payload?: { report?: Report };
}

// `as const` so `action.type` comparisons against these narrow to literals.
export const reportsActions = {
  CREATE_REPORT: 'CREATE_REPORT',
  CLEAR_REPORT: 'CLEAR_REPORT',
} as const;

export const reportsReducer = <
  S extends ReportableState,
  A extends ReportsAction,
>(
  state: S,
  action: A
): S => {
  switch (action.type) {
    case reportsActions.CREATE_REPORT:
      // `as S` is needed because TypeScript types a spread of a generic as
      // `S & {...}` rather than `S`.
      return { ...state, report: action.payload!.report! } as S;
    case reportsActions.CLEAR_REPORT:
      return { ...state, report: {} } as S;
    default:
      return state;
  }
};
